import { apiClient, unwrapApi } from './http';

/**
 * Documents API — /documents/* (PDF blobs)
 */
export async function getDocumentTypes() {
  const { data } = await apiClient.get('/documents/types');
  return unwrapApi(data);
}

export async function downloadInvoice(jobId) {
  const { data } = await apiClient.get(`/documents/invoice/${jobId}`, { responseType: 'blob' });
  return data;
}

export async function downloadDeliveryNote(jobId) {
  const { data } = await apiClient.get(`/documents/delivery-note/${jobId}`, { responseType: 'blob' });
  return data;
}

export async function downloadReceipt(jobId) {
  const { data } = await apiClient.get(`/documents/receipt/${jobId}`, { responseType: 'blob' });
  return data;
}

export async function downloadQuotation(payload) {
  const { data } = await apiClient.post('/documents/quotation', payload, { responseType: 'blob' });
  return data;
}

export async function downloadCashSale(payload) {
  const { data } = await apiClient.post('/documents/cash-sale', payload, { responseType: 'blob' });
  return data;
}

/** Generic helper used by Documents page */
export async function generateDocumentBlob(type, { jobId, payload } = {}) {
  if (type === 'quotation') {
    return downloadQuotation(payload);
  }
  if (type === 'cash-sale') {
    return downloadCashSale(payload);
  }
  if (type === 'invoice') {
    return downloadInvoice(jobId);
  }
  if (type === 'delivery-note') {
    return downloadDeliveryNote(jobId);
  }
  if (type === 'receipt') {
    return downloadReceipt(jobId);
  }
  throw new Error(`Unknown document type: ${type}`);
}

const documentsService = {
  getDocumentTypes,
  downloadInvoice,
  downloadDeliveryNote,
  downloadReceipt,
  downloadQuotation,
  downloadCashSale,
  generateDocumentBlob,
};

export default documentsService;
